// StoreBook's icon set — hand-picked line-art drawn for a cafe ledger,
// not a generic icon-font pack. Each icon ties to something concrete in
// the subject: an open ledger for the dashboard, a torn receipt for sales,
// an abacus for reports, a delivery crate for purchases, and so on.
//
// Usage: <NavIcon name="dashboard" />

const commonProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const ICONS = {
  dashboard: (
    <svg {...commonProps}>
      <path d="M12 6c-1.8-1.2-4-1.6-6.5-1.2v13c2.5-.4 4.7 0 6.5 1.2 1.8-1.2 4-1.6 6.5-1.2v-13C16 4.4 13.8 4.8 12 6z" />
      <line x1="12" y1="6" x2="12" y2="19" />
    </svg>
  ),
  sales: (
    <svg {...commonProps}>
      <path d="M6 3h12v17l-2-1.3L14 20l-2-1.3L10 20l-2-1.3L6 20z" />
      <line x1="8.5" y1="8" x2="15.5" y2="8" />
      <line x1="8.5" y1="11.5" x2="15.5" y2="11.5" />
      <line x1="8.5" y1="15" x2="12.5" y2="15" />
    </svg>
  ),
  tableorders: (
    <svg {...commonProps}>
      <path d="M5 9h11v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z" />
      <path d="M16 10.5h1.5a2.5 2.5 0 0 1 0 5H16" />
      <path d="M8.5 3.5c-.6.7-.6 1.3 0 2M12 3.5c-.6.7-.6 1.3 0 2" />
    </svg>
  ),
  purchases: (
    <svg {...commonProps}>
      <path d="M4 8l8-4 8 4-8 4z" />
      <path d="M4 8v8l8 4 8-4V8" />
      <line x1="12" y1="12" x2="12" y2="20" />
    </svg>
  ),
  products: (
    <svg {...commonProps}>
      <path d="M11 3h6a2 2 0 0 1 2 2v6a2 2 0 0 1-.6 1.4l-8 8a2 2 0 0 1-2.8 0l-5-5a2 2 0 0 1 0-2.8l8-8A2 2 0 0 1 11 3z" />
      <circle cx="15.5" cy="7.5" r="1.3" />
    </svg>
  ),
  categories: (
    <svg {...commonProps}>
      <rect x="4" y="4" width="7" height="7" rx="1" />
      <rect x="13" y="4" width="7" height="7" rx="1" />
      <rect x="4" y="13" width="7" height="7" rx="1" />
      <rect x="13" y="13" width="7" height="7" rx="1" />
    </svg>
  ),
  suppliers: (
    <svg {...commonProps}>
      <rect x="2.5" y="7" width="11" height="8" rx="1" />
      <path d="M13.5 10h4l3 3v2h-7z" />
      <circle cx="7" cy="17.5" r="1.6" />
      <circle cx="17" cy="17.5" r="1.6" />
    </svg>
  ),
  reports: (
    <svg {...commonProps}>
      <rect x="3.5" y="4" width="17" height="16" rx="1.5" />
      <line x1="3.5" y1="9" x2="20.5" y2="9" />
      <line x1="3.5" y1="14" x2="20.5" y2="14" />
      <circle cx="8" cy="9" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="14" cy="9" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="11" cy="14" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="17" cy="14" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  ),
  chat: (
    <svg {...commonProps}>
      <path d="M4 5h16v10H9l-3.5 3.5V15H4z" />
      <line x1="7.5" y1="8.5" x2="16.5" y2="8.5" />
      <line x1="7.5" y1="11.5" x2="13.5" y2="11.5" />
    </svg>
  ),
  calendar: (
    <svg {...commonProps}>
      <rect x="3.5" y="5.5" width="17" height="15" rx="1.5" />
      <line x1="3.5" y1="10" x2="20.5" y2="10" />
      <line x1="7.5" y1="3" x2="7.5" y2="7" />
      <line x1="16.5" y1="3" x2="16.5" y2="7" />
    </svg>
  ),
  users: (
    <svg {...commonProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 20c0-3.5 2.5-6 5.5-6s5.5 2.5 5.5 6" />
      <circle cx="17" cy="9" r="2.3" />
      <path d="M15 13.2c2.5.2 4.3 2.2 4.5 5.3" />
    </svg>
  ),
  clock: (
    <svg {...commonProps}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  ),
  bulkimport: (
    <svg {...commonProps}>
      <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
      <polyline points="8 8 12 4 16 8" />
      <line x1="12" y1="4" x2="12" y2="14" />
    </svg>
  ),
  export: (
    <svg {...commonProps}>
      <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
      <polyline points="8 12 12 16 16 12" />
      <line x1="12" y1="4" x2="12" y2="16" />
    </svg>
  ),
  bell: (
    <svg {...commonProps}>
      <path d="M6 10a6 6 0 0 1 12 0c0 4 1.3 5.3 2 6H4c.7-.7 2-2 2-6z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  ),
  chair: (
    <svg {...commonProps}>
      <path d="M6 4v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4" />
      <line x1="7" y1="15" x2="7" y2="20" />
      <line x1="17" y1="15" x2="17" y2="20" />
      <line x1="6" y1="9" x2="18" y2="9" />
    </svg>
  ),
  trash: (
    <svg {...commonProps}>
      <path d="M5 7h14" />
      <path d="M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7" />
      <path d="M6.5 7l1 12a1.5 1.5 0 0 0 1.5 1.4h6a1.5 1.5 0 0 0 1.5-1.4l1-12" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  ),
  clipboard: (
    <svg {...commonProps}>
      <rect x="5" y="4" width="14" height="17" rx="1.5" />
      <path d="M9 4V3.3A1.3 1.3 0 0 1 10.3 2h3.4A1.3 1.3 0 0 1 15 3.3V4" />
      <line x1="8.5" y1="10" x2="15.5" y2="10" />
      <line x1="8.5" y1="14" x2="15.5" y2="14" />
      <line x1="8.5" y1="18" x2="12.5" y2="18" />
    </svg>
  ),
  folderOpen: (
    <svg {...commonProps}>
      <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5H9l2 2h8.5A1.5 1.5 0 0 1 21 8.5v1.5H4z" />
      <path d="M3 8v10.5A1.5 1.5 0 0 0 4.5 20h14a1.5 1.5 0 0 0 1.47-1.2L21.5 11H5.2a1.5 1.5 0 0 0-1.47 1.2z" />
    </svg>
  ),
  document: (
    <svg {...commonProps}>
      <path d="M7 3h7l4 4v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v4h4" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="16.5" x2="15" y2="16.5" />
    </svg>
  ),
  warning: (
    <svg {...commonProps}>
      <path d="M12 4l9.5 16H2.5z" />
      <line x1="12" y1="10" x2="12" y2="14.5" />
      <circle cx="12" cy="17.3" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  ),
  errorCircle: (
    <svg {...commonProps}>
      <circle cx="12" cy="12" r="8.5" />
      <line x1="9" y1="9" x2="15" y2="15" />
      <line x1="15" y1="9" x2="9" y2="15" />
    </svg>
  ),
  key: (
    <svg {...commonProps}>
      <circle cx="8" cy="14.5" r="4" />
      <path d="M11 11.5l9-9" />
      <path d="M16.5 5.5l2.5 2.5" />
      <path d="M14 8l2 2" />
    </svg>
  ),
  sun: (
    <svg {...commonProps}>
      <circle cx="12" cy="12" r="4" />
      <line x1="12" y1="2.5" x2="12" y2="5" />
      <line x1="12" y1="19" x2="12" y2="21.5" />
      <line x1="4.5" y1="12" x2="2" y2="12" />
      <line x1="22" y1="12" x2="19.5" y2="12" />
      <line x1="5.5" y1="5.5" x2="7.2" y2="7.2" />
      <line x1="16.8" y1="16.8" x2="18.5" y2="18.5" />
      <line x1="18.5" y1="5.5" x2="16.8" y2="7.2" />
      <line x1="7.2" y1="16.8" x2="5.5" y2="18.5" />
    </svg>
  ),
  moon: (
    <svg {...commonProps}>
      <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />
    </svg>
  ),
};

export default function NavIcon({ name, size = 18 }) {
  const icon = ICONS[name];
  if (!icon) return null;
  return (
    <span className="nav-icon" style={{ width: size, height: size }}>
      {icon}
    </span>
  );
}
